import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

export default function ProductCard({ product }) {
  const [hovered, setHovered] = useState(false);

  return (
    <Link
      to={`/product/${product.id}`}
      className="product-card"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="card-image-wrap">
        {product.badge && (
          <span className="card-badge">{product.badge}</span>
        )}
        <img
          src={product.images[hovered && product.images[1] ? 1 : 0]}
          alt={product.name}
          className="card-img"
        />
        <div className="card-hover-cta">
          <span>View Piece</span>
        </div>
      </div>
      <div className="card-info">
        <span className="card-category">{product.category}</span>
        <h3 className="card-name">{product.name}</h3>
        <p className="card-price">€{product.price}</p>
      </div>
    </Link>
  );
}
